import { useState } from 'react';
import { api, ApiError } from '../api.ts';
import { INCIDENT_LABELS } from '../ratings.ts';

const ERRORS: Record<string, string> = {
  ALREADY_REPORTED: 'Cet incident a déjà été signalé pour cette mission.',
  MISSION_NOT_STARTED: 'La mission n’a pas encore commencé.',
  INVALID_ACTUAL_END: 'L’heure de départ doit se situer pendant la mission.',
  INVALID_NOTE: 'Le commentaire est trop long.',
};

// Signalement par l'établissement. Il ne sanctionne rien : l'équipe vérifie et l'extra peut répondre.
export function IncidentPanel({ missionId, startsAt, endsAt }: { missionId: string; startsAt: string; endsAt: string }) {
  const [kind, setKind] = useState<'NO_SHOW' | 'EARLY_DEPARTURE' | null>(null);
  const [note, setNote] = useState('');
  const [actualEnd, setActualEnd] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function send() {
    if (!kind) return;
    setBusy(true);
    setError(null);
    try {
      await api.post(`/missions/${missionId}/incidents`, { kind, note: note || undefined, actualEnd: kind === 'EARLY_DEPARTURE' ? new Date(actualEnd).toISOString() : undefined });
      setSent(true);
      setKind(null);
    } catch (err) {
      setError(err instanceof ApiError ? ERRORS[err.code] ?? 'Signalement impossible.' : 'Signalement impossible.');
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return <div className="badge badge-pending" style={{ justifyContent: 'center', padding: '10px 14px', lineHeight: 1.5 }}>Signalement transmis. L'équipe Mon Extra vérifie la situation et l'extra peut donner sa version : rien n'est décidé automatiquement.</div>;
  }
  if (!kind) {
    return (
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <button className="btn btn-danger-outline btn-sm" onClick={() => setKind('NO_SHOW')}>Signaler une absence</button>
        <button className="btn btn-danger-outline btn-sm" onClick={() => setKind('EARLY_DEPARTURE')}>Signaler un départ anticipé</button>
      </div>
    );
  }
  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ fontWeight: 800 }}>{INCIDENT_LABELS[kind]}</div>
      <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
        Ce signalement ne sanctionne personne : l'équipe Mon Extra vérifie, l'extra peut répondre, puis une personne décide.
      </div>
      {error && <div className="error-banner">{error}</div>}
      {kind === 'EARLY_DEPARTURE' && (
        <div>
          <label className="field-label" htmlFor="actual-end">Heure réelle de départ</label>
          <input id="actual-end" className="input" type="datetime-local" min={startsAt.slice(0, 16)} max={endsAt.slice(0, 16)} value={actualEnd} onChange={(e) => setActualEnd(e.target.value)} />
        </div>
      )}
      <textarea className="input" rows={3} maxLength={1000} placeholder="Ce qui s'est passé (facultatif)" value={note} onChange={(e) => setNote(e.target.value)} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button className="btn btn-primary btn-sm" onClick={send} disabled={busy || (kind === 'EARLY_DEPARTURE' && !actualEnd)}>Envoyer le signalement</button>
        <button className="btn btn-secondary btn-sm" onClick={() => setKind(null)}>Annuler</button>
      </div>
    </div>
  );
}
